<template>

 <v-dialog max-width="100%" v-model="showDialog">
    <v-btn flat fab slot="activator" style='margin-top:-20px' 
        class="indigo accent-1"
        light small mt-4 absolute middle right ><v-icon>edit</v-icon></v-btn>

    <v-card>
      <v-card-title>
        <h2>Edit the person {{person.firstNames}} {{person.surname}}</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-tabs color='indigo darken-3' dark grow v-model="tabStatus.activeTab">
            <v-tab>Personal Details</v-tab>
            <!-- REMOVED v-tab>Enlistment</v-tab -->
            <v-tab>Service Details</v-tab>
            <v-tab>Notes, Links, Images</v-tab>
            <v-tab>Fate, Postwar</v-tab>              
            <v-tab-item>
              <PersonalDetailsTab v-bind:person="person" @errorOnTab="onErrorOnTab(0)" ref="personalDetailsTab"/>
            </v-tab-item>
            <!-- REMOVED... v-tab-item>
              <EnlistmentTab v-bind:person="person" @errorOnTab="onErrorOnTab(1)" ref="enlistmentTab"/> 
            </v-tab-item -->
            <v-tab-item>
              <ServiceTab v-bind:person="person" @errorOnTab="onErrorOnTab(1)" ref="serviceTab"/> 
            </v-tab-item>
            <v-tab-item>
              <LinksTab v-bind:person="person" @errorOnTab="onErrorOnTab(2)" ref="linksTab"/> 
            </v-tab-item>
            <v-tab-item>
              <FatePostwarTab v-bind:person="person" @errorOnTab="onErrorOnTab(3)" ref="fatePostwarTab"/>
            </v-tab-item>
          </v-tabs>
        
          <v-divider/>

          <provenance-and-note v-bind:record="updateContext"/>

          <v-layout row>
             <v-flex xs12>
                <div class="danger-alert" v-html="error"></div>
              </v-flex>
            </v-layout>

            <v-layout row>          
              <v-flex xs4>
              </v-flex>
              <v-flex xs4>
                <v-btn dark class="indigo darken-1" @click='update' :loading="loading"><v-icon left >save_alt</v-icon>Save</v-btn>
              </v-flex>
              <v-flex xs4>
              </v-flex>
            </v-layout>

        </v-form>
      </v-card-text>
    </v-card>
     
 </v-dialog>    

</template>        

<script>

import Panel from '@/components/Panel' ;
import PersonalDetailsTab from './Person/PersonalDetailsTab' ;
// REMOVED import EnlistmentTab from  './Person/EnlistmentTab' ;
import ServiceTab from  './Person/ServiceTab' ;
import LinksTab from  './Person/LinksTab' ;
import FatePostwarTab from  './Person/FatePostwarTab' ;

import PeopleService from "@/services/PeopleService" ;

export default {
  components: { Panel, PeopleService, PersonalDetailsTab, ServiceTab, LinksTab, FatePostwarTab },
  props: {
    person: null
  },

  data () {
    return {
      updateContext: { 
        provenance: '',
        note: ''
      },
      error: null,
      /*
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Minimum of 8 characters is required.'
      },
      */
      tabStatus: {
        tabToSwapTo: -1,
        activeTab: 0
      },
      loading: false,
      showDialog: false 
    }
  },

  async mounted () {
    console.log("in personedit mounted, person=" + JSON.stringify(this.person)) ;
    // await this.$getCodes() ;
    // console.log("got codes") ;
    // await this.readData() ;
  },

  methods: {
    onErrorOnTab: function (newTab) {
      console.log("==in swap tab with " + newTab) ;
      this.tabStatus.tabToSwapTo = newTab ;
    },

    async update () {

      console.log("IN PE UPDATE>>>") ;
      this.$refs.personalDetailsTab.finaliseUpdates() ;
      // this.$refs.enlistmentTab.finaliseUpdates() ;
      this.$refs.serviceTab.finaliseUpdates() ;
      this.$refs.linksTab.finaliseUpdates() ;
      this.$refs.fatePostwarTab.finaliseUpdates() ;      

      this.tabStatus.tabToSwapTo = -1 ; // one of the validators may cause this to be set
      if (!this.$refs.form.validate()) {
        if (this.tabStatus.tabToSwapTo >= 0) this.tabStatus.activeTab = this.tabStatus.tabToSwapTo ;
        return ;
      }
      this.error = null ;

      try {
        console.log("PERSON UPDATE: " + JSON.stringify(this.person)) ;
        // if (this.person) return ;
        this.loading = true ;     

        const response = await PeopleService.edit(this.person, this.updateContext) ;
        console.log("update response: " + JSON.stringify(response)) ;

        // this.message = response.data.message
        console.log("success edit, resp data=" + JSON.stringify(response.data)) ;
        this.showDialog = false ;      
        this.$renderToastInParent(this, "Person updated") ;
        this.$emit('onUpdate', response.data) ;
      }
      catch (err) {
        console.log("catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        this.loading = false ;
      }      
    } 
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PersonEdit.vue